import { render } from "./opportunity.component.vue?vue&type=template&id=7f94677d&ts=true"
import script from "./opportunity.component.vue?vue&type=script&lang=ts"
export * from "./opportunity.component.vue?vue&type=script&lang=ts"

import "./opportunity.component.vue?vue&type=style&index=0&id=7f94677d&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__